'use client'

import React from "react"
import { getEnv } from "./utilities"

import DatalayerPageView from "./DatalayerPageView"
import DatalayerClickManager from "./DatalayerClickManager"

interface DatalayerProps {
  slug: string;
  siteName: string;
  locale: string;
}

export const Datalayer = ({
  slug,
  siteName,
  locale,
}: DatalayerProps) => {
  // console.log('----------------- Datalayer -------------------')

  let hostname = '';
  if(typeof window !== 'undefined') {
    hostname = window?.location?.hostname || '';
  }
  const environment = getEnv(hostname)

  // console.log('window.location.hostname', hostname)
  // console.log('slug', slug)
  // console.log('siteName', siteName)
  // console.log('locale', locale) 
  // console.log('environment', environment) 
  /*
    There is going to be 1 Datalayer Click manager, if you're clicking something, you catch the click and pass to a specific function.
    There is a Datalayer Page View, which is always there.
    There will likely be multiple Submit trackers for the different form types.

    TODO: 
      - Most of the Click handlers in the manager
      - Form submission tracking
  */

  return (
    <div className="datalayer-gtm hidden hide">
      <DatalayerPageView
        hostname={hostname}
        locale={locale}
        slug={slug}
        siteName={siteName}
        environment={environment} 
      />
      <DatalayerClickManager
        hostname={hostname}
        locale={locale}
        slug={slug}
        siteName={siteName}
        environment={environment} 
      />
    </div>
  );
}
